export default "__VITE_PUBLIC_ASSET__9ffb50a3__"